import { Grid, Typography } from "@material-ui/core";
import SimpleTable from "../CustomTable/SimpleTable";
import NoData from "../BillsFilter/NotFound";

const ProjectBuyers = ({ devices }) => {
  const styles = {
    container: { padding: "5px 15px", margin: "10px auto" },
  };
  let projectUsers = [];
  const users = devices.map((device) => device.water_meter_user_info);
  users.forEach((user) => {
    if (projectUsers.length === 0) {
      projectUsers.push(user);
    } else {
      let isThere = projectUsers.filter(
        (index) => index.user_id === user.user_id
      );
      if (isThere.length === 0) {
        projectUsers.push(user);
      }
    }
  });
  const tableHeaders = [
    { title: "نام خریدار", key: "buyerName" },
    { title: "شماره تماس", key: "buyerPhone" },
    { title: "تعداد دستگاه", key: "buyerDevices" },
  ];
  let tableData = [];
  projectUsers.forEach((user) =>
    tableData.push({
      buyerName: `${user.user_name} ${user.user_lastname}`,
      buyerPhone: user.user_phone,
      buyerDevices: ` ${
        devices.filter(
          (device) => device.water_meter_user_info.user_id === user.user_id
        ).length
      } عدد`,
    })
  );
  return (
    <>
      <Grid item xs={11} sm={12} md={12} lg={12} style={styles.container}>
        <Typography id="transition-modal-title" variant="h6" component="h6">
          لیست خریداران
        </Typography>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} style={styles.container}>
        {projectUsers.length > 0 ? (
          <SimpleTable
            hasIndex={true}
            hasLink={false}
            header={tableHeaders}
            data={tableData}
            darkHeader={true}
          />
        ) : (
          <NoData message={"خریداری در این پروژه موجود نیست"} />
        )}
      </Grid>
    </>
  );
};
export default ProjectBuyers;
